export default "__VITE_ASSET__MeT_P4py__"